import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import {selectedPresentationSelector} from '../../../../store/selectors/presentation.selectors';
import {useFetchPresParamValues} from '../../../components/presentationList/presentationLinks/queries';
import Select, {Option} from '../../../components/common/Select';

interface IRequestParamFilterProps {
    selectedParams: Record<string, Option | undefined>;
    setSelectedParams: (selectedParams: (prevState: Record<string, Option | undefined>) => Record<string, Option | undefined>) => void;
}

function RequestParamFilter({selectedParams, setSelectedParams}: IRequestParamFilterProps): JSX.Element | null {
    const selectedPresentation = useSelector(selectedPresentationSelector);
    const {data: linkParams} = useFetchPresParamValues({
        presentationId: selectedPresentation._id,
        enabled: !!selectedPresentation._id,
    });

    const [, setRequestParamInputSearch] = useState<string>('');

    const handleSelectChange = (paramKey: string, selectedOption: Option | null): void => {
        setSelectedParams((prevState: Record<string, Option | undefined>) => ({
            ...prevState,
            [paramKey]: selectedOption || undefined,
        }));
    };

    const matchedParams =
        selectedPresentation.requestParams?.map((param) => {
            return {
                key: param.key,
                values: linkParams?.params?.map((linkParam) => linkParam.filter((item) => item.key === param.key)).flat() || [],
            };
        }) || [];

    if (!selectedPresentation?.requestParams?.length) return null;

    return (
        <div className="c-reportFilter__group">
            {matchedParams.slice(0, 10).map((paramData, index) => {
                const uniqueValues = Array.from(new Set(paramData.values.map(({value}) => value)));
                const options = [{value: '', label: 'Any'}, ...uniqueValues.map((value) => ({value, label: value}))];
                return (
                    <div key={`${paramData.key}-${index}`} className="c-reportFilter__group_filter">
                        <label>
                            {paramData.key}
                            <Select
                                options={options}
                                value={selectedParams[paramData.key]}
                                onChange={(selectedOption) => handleSelectChange(paramData.key, selectedOption)}
                                onInputChange={(e) => setRequestParamInputSearch(e)}
                            />
                        </label>
                    </div>
                );
            })}
        </div>
    );
}

export default RequestParamFilter;
